<template>
  <stacked-layout>
    <template v-slot:first>
        <v-spacer></v-spacer>
        <template v-if="!subreports.venuePaymentsDetail.loading">
            <v-col cols="12" lg="3">
                <bw-summation
                    class="flex-grow-1"
                    :settings="subreports.venuePaymentsDetail.summation"
                    :partner="partner"
                ></bw-summation>
            </v-col>
        </template>
        <template v-else>
          <v-progress-circular 
              indeterminate
              color="primary"
          ></v-progress-circular>
        </template>
    </template>
    <template v-slot:second>
      <table-report-wr
          :settings="subreports.venuePaymentsDetail"
          :partner="partner"
          :helper="reportHelper"
      ></table-report-wr>
    </template>
    <template v-slot:fourth>
      <div id="exportContainer"></div>
    </template>
  </stacked-layout>
</template>

<script>
import TableReportWr from "../components/tableReportWr";
import StackedLayout from '@components/Layouts/StackedLayout';
import BwSummation from '../components/summation';
import ReportHelper from "../reportHelper.js";

export default {
  components: {
    StackedLayout,
    BwSummation,
    TableReportWr,
  },
  props: ReportHelper.propsObject,
  watch: ReportHelper.watchObject,
  data: () => ReportHelper.formatData({
    requiredFilters: [],
    filters: {
      month: moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DDTHH:mm:ss'),
    },
    subreports: {
      venuePaymentsDetail: {
        tableData: {
          label: 'Venue Payments Detail',
          columnOptions: {
						'Bandwango Internal': {name: 'Bandwango Internal'},
            Venue: {name: 'Venue'},
            Pass: {name: 'Pass'},
            Item: {name: 'Item'},
            Attribute: {name: 'Attribute'},
						'Payment Type': {name: 'Payment Type'},
            Amount: {
              name: 'Amount',
              format: 'currency',
              align: 'end'
            },
            Date: {
              name: 'Date',
              format: 'dateTime',
            },
          },
          checkedColumns: [
						'Bandwango Internal',
						'Venue',
						'Pass',
						'Item',
						'Attribute',
						'Payment Type',
						'Amount',
						'Date',
						'purchaseDate',
					],
          params: {
						functionName: 'venueTransactions',
					},
          totalizer: {
            fieldName: 'Bandwango Internal',
            totalFieldName: 'Amount',
            onEmpty: {
							'Bandwango Internal': 'Total',
							Amount: 0
						},
          }
        },
        summation: {
          label: 'Total',
          isMoney: true,
          showComparison: false,
          value: 0
        }
      },
    },
  }),
  computed: {
    displayFilters() {
      return {
        month: {
          name: 'Month',
          sort: 1
        },
      };
    },
  },
  async mounted() {
    this.reportHelper = new ReportHelper(this);
    await this.reportHelper.init();
  }
}
</script>